import React, { useState, useEffect } from 'react';
import Modal from '../../../shared/components/ui/Modal';
import Button from '../../../shared/components/ui/Button';

interface EditTacticsNameModalProps {
  isOpen: boolean;
  currentName: string;
  isSaving: boolean;
  onClose: () => void;
  onSave: (newName: string) => void;
}

const EditTacticsNameModal: React.FC<EditTacticsNameModalProps> = ({
  isOpen,
  currentName,
  isSaving,
  onClose,
  onSave,
}) => {
  const [name, setName] = useState(currentName);

  useEffect(() => {
    if (isOpen) {
      setName(currentName);
    }
  }, [isOpen, currentName]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSave(name.trim());
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Rename Tactics Configuration" className="max-w-md">
      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        <div>
          <label htmlFor="tactics-name" className="block text-sm font-medium text-gray-700 mb-2">
            Configuration name
          </label>
          <input
            id="tactics-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter configuration name"
            className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            maxLength={80}
            autoFocus
          />
          <p className="text-xs text-gray-400 mt-1">
            Choose a descriptive name for this tactics configuration.
          </p>
        </div>

        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <Button type="button" variant="ghost" onClick={onClose} disabled={isSaving}>
            Close
          </Button>
          <Button type="submit" variant="primary" disabled={isSaving || !name.trim()}>
            {isSaving ? 'Saving…' : 'Save'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default EditTacticsNameModal;
